export default "__VITE_ASSET__DvUCP6Tw__"